import React, { useState } from 'react';

/**
 * <Tabs
 *   tabs={[{id:'overview', label:'Overview', icon:BarChart},
 *          {id:'tenants',  label:'Tenants',  icon:Users, badge:'12'}]}
 *   activeId={active} onChange={setActive} />
 *
 * Or use controlled = false:
 *   <Tabs tabs={[...]} defaultId="overview">{(id) => <PanelFor id={id}/>}</Tabs>
 */
const Tabs = ({ tabs = [], activeId, onChange, defaultId, children, className = '' }) => {
    const [internal, setInternal] = useState(defaultId || tabs[0]?.id);
    const active = activeId ?? internal;
    const setActive = (id) => { setInternal(id); onChange?.(id); };

    return (
        <div className={className}>
            <div className="border-b border-neutral-200/70">
                <div className="flex gap-1 overflow-x-auto -mb-px scrollbar-thin">
                    {tabs.map(t => {
                        const isActive = t.id === active;
                        return (
                            <button
                                key={t.id}
                                onClick={() => setActive(t.id)}
                                className={`group relative flex items-center gap-2 px-3 py-2.5 text-sm font-medium
                                            border-b-2 whitespace-nowrap transition-colors
                                            ${isActive
                                                ? 'border-primary-700 text-primary-800'
                                                : 'border-transparent text-neutral-500 hover:text-neutral-900 hover:border-neutral-300'}`}>
                                {t.icon && <t.icon className={`h-4 w-4 ${isActive ? 'text-primary-700' : 'text-neutral-400 group-hover:text-neutral-600'}`} />}
                                {t.label}
                                {t.badge != null && (
                                    <span className={`ml-1 text-xs px-1.5 py-0.5 rounded-full font-normal
                                        ${isActive ? 'bg-primary-100 text-primary-700' : 'bg-neutral-100 text-neutral-500'}`}>
                                        {t.badge}
                                    </span>
                                )}
                            </button>
                        );
                    })}
                </div>
            </div>
            {typeof children === 'function' ? children(active) : (
                <div className="pt-6 animate-fade-in">{children}</div>
            )}
        </div>
    );
};

export default Tabs;
